import * as yup from "yup";

import { checkSINValidity } from "../../../common/Common";

export const RL1SlipSetupValidationSchema = yup.object({
	// applyAdjustments: yup.string().required("Apply Adjustments is required"),
	address: yup
		.string()
		.required("Address is required")
		.max(50, "Address has at most 50 characters"),
	socialInsuranceNumber: yup
		.string()
		.test("is-masked-or-not", "Invalid value", function (value: any) {
			let sin = value && value.replace(/-/g, "");
			const output = checkSINValidity(sin);

			let maxLength = 11;

			if (value && value.charAt(2) === "*") {
				maxLength = 7;
				if (value && value.length == maxLength) {
					return true;
				} else {
					return this.createError({
						message: "Invalid Social Insuarance Number",
						path: this.path,
					});
				}
			} else {
				if (value && value.length == maxLength && output % 10 === 0) {
					return true;
				} else {
					return this.createError({
						message: "Invalid Social Insuarance Number",
						path: this.path,
					});
				}
			}
		})
		.required("Social Insuarance is required"),
	firstName: yup
		.string()
		.required("First Name is required")
		.max(12, "First Name has at most 12 characters"),
	lastName: yup
		.string()
		.required("Last Name is required")
		.max(20, "Last Name has at most 20 characters"),
	initials: yup.string().max(1, "maximum one character"),
	city: yup
		.string()
		.required("City is required")
		.max(28, "City has at most 28 characters"),
	province: yup.string().required("Province is required"),
	// postalCode: yup
	//   .string()
	//   .required("Employee PostCode is required")
	//   .max(10, "Post Code has at most 10 characters"),
	country: yup.string().required("Employee Country is required"),
	payFrequency: yup.string().required("Payroll Schedule is required"),
	// pensionablePeriod: yup
	// 	.number()
	// 	.transform((value, originalValue) =>
	// 		String(originalValue).trim() === "" ? null : value
	// 	)
	// 	.required("pensionable Periods is required")
	// 	.nullable()
	// 	.test(
	// 		"is-less-than-or-equal-to-payFrequency",
	// 		"pensionable Periods must be less than or equal to Pay Periods",
	// 		function (value: any) {
	// 			const { payFrequency } = this.parent;
	// 			return value <= payFrequency;
	// 		}
	// 	),
	slipType: yup.number().required("slipType is required"),
	// code:yup.string().when("boxOAutresRevenus",{
	//   is: (name: string) => name && name.length > 0,
	//   then: yup.string().required('Code is required'),
	//   // otherwise: yup.string(),
	// }),
	// boxOAutresRevenus:yup.string().when("code",{

	//   name && name.trim().length > 0},
	//   then: yup.string().required('Box O is required because of code selection'),
	//   // otherwise: yup.string(),
	// }),

	// boxOAutresRevenus: yup.string().when('code', {
	//   is: (value: string) => value !== undefined,
	//   then: yup.string().required('boxOAutresRevenus is required'),
	// }),
	// code: yup.string().when('boxOAutresRevenus', {
	//   is: (value: string) => value && value.length > 0,
	//   then: yup.string().required('Code is required'),
	// }),

	// boxOAutresRevenus: yup
	// 	.string()
	// 	.nullable()
	// 	.test(
	// 		"requiredWithCode",
	// 		"boxOAutresRevenus is required",
	// 		function (value) {
	// 			const selectValue = this.resolve(yup.ref("code"));
	// 			return selectValue !== null && undefined ? !!value : true;
	// 		}
	// 	),
	// code: yup
	// 	.string()
	// 	.nullable()
	// 	.test("requiredWithBoxO", "Code is required", function (value) {
	// 		const textFieldValue = this.resolve(yup.ref("boxOAutresRevenus"));
	// 		return textFieldValue !== "" && null ? !!value : true;
	// 	}),

	boxOAutresRevenus: yup
		.string()
		.nullable()
		.test(
			"boxO-required",
			"O-Autres revenus is required when Code is filled",
			function (value) {
				const { code } = this.parent;
				if (code && !value) return false;
				return true;
			},
		),
	code: yup
		.string()
		.nullable()
		.test(
			"code-required",
			"Code is required when O-Autres revenus is filled",
			function (value) {
				const { boxOAutresRevenus } = this.parent;
				if (boxOAutresRevenus && !value) return false;
				return true;
			},
		),

	// email: yup.string().nullable().email("Please enter valid Email"),
	email: yup
		.string()
		.trim()
		.email("Must be a valid email address")
		// .matches(/\.[A-Za-z]{2,}$/, "Must be a valid email address")\
		.matches(/\.[A-Za-z]{2,}$/, {
			message: "Must be a valid email address",
			excludeEmptyString: true,
		})
		.nullable(),
});
